// extracted by mini-css-extract-plugin
export var attachmentContainer = "_ls-0";
export var fileList = "_ls-2";
export var removeFileButton = "_ls-1";